import { CHROME_EXTENSION, EMBEDDED } from '../constants/build'

export const isExtension = mode => mode === CHROME_EXTENSION
export const isEmbedded = mode => mode === EMBEDDED
